module.exports = __webpack_public_path__ + "img/Bahrain.1a8304dd.gif";